module.exports = __webpack_public_path__ + "img/fastdelivery.54542928.svg";